import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

export function useDrafts(id: string) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const result = useQuery({
    queryKey: 'client-campaign-drafts',
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/client/campaign/${id}/drafts`,
        token
      }).then((response: { drafts: Api.Client.Draft[] } | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    queryData: { id, token },
    enabled: !!token
  });

  return {
    isLoading: result.isLoading,
    refetch: result.refetch,
    error: result.error,
    data: result.data && 'drafts' in result.data ? result.data : { drafts: [] }
  };
}
